export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";